"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementInteraction;

var _customEvent = _interopRequireDefault(require("./custom-event"));

function elementInteraction(elementInteractionHeader) {
  (0, _customEvent.default)('ELEMENT_INTERACTION_EVENT', null, {
    elementInteractionHeader: elementInteractionHeader
  });
}